import SpinningLoader from '@/components/common/SpinningLoader';

import LoginForm from './LoginForm';
import useLogin from './useLogin';
import useSsoLogin from './useSsoLogin';

const LoginAuth = () => {
  const {isSigningIn} = useSsoLogin();
  const {isLoading, handleLogin, handleChange} = useLogin();
  if (isSigningIn) {
    return (
      <div className="flex h-screen items-center justify-center">
        <SpinningLoader />
      </div>
    );
  }
  return (
    <LoginForm
      isLoading={isLoading}
      handleLogin={handleLogin}
      handleChange={handleChange}
    />
  );
};

export default LoginAuth;
